// @ts-nocheck
import { createAction, createAsyncAction } from '../../../core/store/actionCreators';
import {
  CHANGE_SUBSCRIPTION,
  CLOSE_SUBSCRIPTION,
  CREATE_SUPPORT_PRODUCT,
  DESELECT_SUBSCRIPTION,
  FETCH_CHANNELS,
  FETCH_PRODUCTS,
  FETCH_SUBSCRIPTION,
  FETCH_SUBSCRIPTIONS,
  REACTIVATE_SUBSCRIPTION,
  RESET_CREDIT_CARD,
  INVALIDATE_CACHE,
  CLOSE_PARTNER_SUBSCRIPTION,
  CREATE_PARTNER_SUBSCRIPTION,
  DELETE_PAYMENT_BLOCK,
  FETCH_DISCOUNT_REASONS,
  ADD_SUBSCRIPTION_DISCOUNT,
} from './subscriptionActionTypes';
import SubscriptionService from '../services/SubscriptionService';
import ProductService from '../services/ProductService';
import PartnerService from '../../customers/services/PartnerService';
import CustomerService from '../../customers/services/CustomerService';

export const fetchSubscriptions = createAsyncAction(
  FETCH_SUBSCRIPTIONS,
  async (userId, expired, page, size) => {
    const { data } = await SubscriptionService.fetchSubscriptions(userId, expired, page, size);
    return data;
  }
);

export const fetchSubscription = createAsyncAction(
  FETCH_SUBSCRIPTION,
  async (userId, subscriptionId) => {
    const { data } = await SubscriptionService.fetchSubscription(userId, subscriptionId);
    return data;
  }
);

export const closeSubscription = createAsyncAction(
  CLOSE_SUBSCRIPTION,
  async (userId, subscriptionId, force) => {
    const { data } = await SubscriptionService.closeSubscription(userId, subscriptionId, force);
    return data;
  }
);

export const reactivateSubscription = createAsyncAction(
  REACTIVATE_SUBSCRIPTION,
  async (userId, product) => {
    const { data } = await ProductService.restoreProduct(userId, product);
    return data;
  }
);

export const changeSubscription = createAsyncAction(
  CHANGE_SUBSCRIPTION,
  async (userId, subscriptionId, productId, product, force) => {
    const { data } = await ProductService.updateProduct(
      userId,
      subscriptionId,
      productId,
      product,
      force
    );
    return data;
  }
);

export const createSupportProduct = createAsyncAction(
  CREATE_SUPPORT_PRODUCT,
  async (userId, product) => {
    const { data } = await ProductService.createSupportProduct(userId, product);
    return data;
  }
);

export const fetchChannels = createAsyncAction(FETCH_CHANNELS, async () => {
  const { data } = await ProductService.fetchChannels();
  return data;
});

export const fetchProducts = createAsyncAction(FETCH_PRODUCTS, async () => {
  const { data } = await ProductService.fetchProducts();
  return data;
});

export const resetCreditCard = createAsyncAction(RESET_CREDIT_CARD, async pic => {
  const { data } = await CustomerService.deletePicDiscounts(pic);
  return data;
});

export const removePaymentBlock = createAsyncAction(DELETE_PAYMENT_BLOCK, async pic => {
  const { data } = await CustomerService.deletePicBlock(pic);
  return data;
});

export const removeUserBlock = createAsyncAction(DELETE_PAYMENT_BLOCK, async userId => {
  const { data } = await CustomerService.deleteUserBlock(userId);
  return data;
});

export const deselectSubscription = createAction(DESELECT_SUBSCRIPTION);

export const invalidateCache = createAsyncAction(INVALIDATE_CACHE, async userId => {
  const { data } = await SubscriptionService.invalidateCache(userId);
  return data;
});

export const createPartnerSubscription = createAsyncAction(
  CREATE_PARTNER_SUBSCRIPTION,
  async (email, product) => {
    const { data } = await PartnerService.createSubscription(email, product);
    return data;
  }
);

export const closePartnerSubscription = createAsyncAction(
  CLOSE_PARTNER_SUBSCRIPTION,
  async vasToken => {
    const { data } = await PartnerService.closeSubscription(vasToken);
    return data;
  }
);

export const fetchDiscountReasons = createAsyncAction(FETCH_DISCOUNT_REASONS, async () => {
  const { data } = await SubscriptionService.fetchDiscountReasons();
  return data;
});

export const addSubscriptionDiscount = createAsyncAction(
  ADD_SUBSCRIPTION_DISCOUNT,
  async (userId, subscriptionId, discount) => {
    const { data } = await SubscriptionService.addSubscriptionDiscount(userId, subscriptionId, discount);
    return data;
  }
);
